/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

export const initialState = {
  isLoading: false,
  errorMessage: '',
  isSuccess: false,
  isRemovingCompleted: false,
  isRemoving: false,
  removingError: '',
  allAdmins: [],
  connectivity: false,
  deleteData: {},
  isAddingCompleted: false,
  isMasterLoading: false,
  masterErrorMessage: '',
  isMasterSuccess: false,
  masterAdmin: {},
  isChangingCompleted: false,
  isChanging: false,
  changingError: '',
};
//
export const getAdminsSlice = createSlice({
  name: 'feature/get-admins',
  initialState,
  reducers: {
    getAdmins: (state) => {
      state.isLoading = true;
      state.errorMessage = '';
      state.isSuccess = false;
    },
    getAdminsSuccess: (state, action) => {
      state.isLoading = false;
      state.errorMessage = '';
      state.isSuccess = true;
      state.allAdmins = action.payload;
    },
    getAdminsError: (state, action) => {
      state.isLoading = false;
      state.errorMessage = action.payload;
      state.isSuccess = false;
    },
    removeAdmins: (state) => {
      state.isRemoving = true;
      state.removingError = '';
      state.isRemovingCompleted = false;
    },
    removeAdminsSuccess: (state, action) => {
      state.isRemoving = false;
      state.removingError = '';
      state.deleteData = action.payload;
      state.isRemovingCompleted = true;
    },
    removeAdminsError: (state, action) => {
      state.isRemoving = false;
      state.removingError = action.payload;
      state.isRemovingCompleted = false;
    },
    getMasterAdmin: (state) => {
      state.isMasterLoading = true;
      state.masterErrorMessage = '';
      state.isMasterSuccess = false;
    },
    getMasterAdminsSuccess: (state, action) => {
      state.isMasterLoading = false;
      state.masterErrorMessage = '';
      state.isMasterSuccess = true;
      state.masterAdmin = action.payload;
    },
    getMasterAdminsError: (state, action) => {
      state.isMasterLoading = false;
      state.masterErrorMessage = action.payload;
      state.isMasterSuccess = false;
    },
    changeAdmins: (state) => {
      state.isChanging = true;
      state.changingError = '';
      state.isChangingCompleted = false;
    },
    changeAdminsSuccess: (state) => {
      state.isChanging = false;
      state.changingError = '';
      state.isChangingCompleted = true;
    },
    changeAdminsError: (state, action) => {
      state.isChanging = false;
      state.changingError = action.payload;
      state.isChangingCompleted = false;
    },
  },
});
//
export const { actions: getAdminsActions } = getAdminsSlice;
